module.exports = __webpack_public_path__ + "img/assettrackingapikey.616c7869.png";